// Version : 0.0.1
// Author : Vignesh
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** ADD INDIVIDUAL LOAN PROPOSAL START ***************** */
export const addIndividualLoanProposal = (addData: any) => {
	const data = {
		AddPersonalLoanIndexDataToken: addData,
	};
	const url = `${API_URL}addPersonalLoanIndex`;
	return makeApiCall(url, data);
};
/** ***************** ADD INDIVIDUAL LOAN PROPOSAL END ***************** */

/** ***************** UPDATE INDIVIDUAL LOAN PROPOSAL START ***************** */
export const updateIndividualLoanProposal = (updateData: any) => {
	const data = {
		UpdatePersonalLoanIndexDataToken: updateData,
	};
	const url = `${API_URL}updatePersonalLoanIndex`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE INDIVIDUAL LOAN PROPOSAL END ***************** */

/** ***************** SEARCH MEMBER LOAN PROPOSAL START ***************** */
export const fetchSearchMemberLoanProposalList = (listData: any) => {
	const data = {
		GetSearchMemberDetailsForPersonalLoanToken: listData,
	};
	const url = `${API_URL}getSearchMemberDetailsForPersonalLoan`;
	return makeApiCall(url, data);
};
/** ***************** SEARCH MEMBER LOAN PROPOSAL END ***************** */
